import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import Toast from 'bootstrap/js/dist/toast';
import { ToastItem } from './toast-item.model';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toast-item',
    templateUrl: './toast-item.component.html',
    styleUrls: ['./toast-item.component.scss'],
    imports: [CommonModule]
})
export class ToastItemBaseComponent implements AfterViewInit, OnDestroy {
  @Input() public toastItem: ToastItem;
  @Output() public onClose: EventEmitter<boolean>;
  public eToastItemTypeList: typeof EToastItemType;

  @ViewChild('toastContainer') public toastContainerRef: ElementRef<HTMLDivElement> | undefined;
  private toast: Toast | undefined;

  public constructor() {
    this.toastItem = new ToastItem();
    this.onClose = new EventEmitter<boolean>();
    this.eToastItemTypeList = EToastItemType;
  }

  ngAfterViewInit(): void {
    if (this.toastContainerRef) {
      this.toast = new Toast(this.toastContainerRef.nativeElement, {
        animation: this.toastItem.animation,
        autohide: this.toastItem.autohide,
        delay: this.toastItem.autoHideDelayInSeconds * 1000
      });
      this.toast.show();
    }
  }

  public ngOnDestroy(): void {
    this.toast?.dispose();
  }
}
